export const CLIENT_TYPES = {
  AGENCY: 'Agency',
  COMPANY: 'Company',
} as const;
